var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6667H5.33333V15.3334H8V12.6667ZM13.3333 12.6667H10.6667V15.3334H13.3333V12.6667ZM18.6667 12.6667H16V15.3334H18.6667V12.6667ZM21.3333 3.33341H20V0.666748H17.3333V3.33341H6.66667V0.666748H4V3.33341H2.66667C1.18667 3.33341 0.0133333 4.53341 0.0133333 6.00008L0 24.6667C0 26.1334 1.18667 27.3334 2.66667 27.3334H21.3333C22.8 27.3334 24 26.1334 24 24.6667V6.00008C24 4.53341 22.8 3.33341 21.3333 3.33341ZM21.3333 24.6667H2.66667V10.0001H21.3333V24.6667Z",
    fill: "#8692A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.62613a5f4cde010672b2399dd62e918b.svg";
export { ForwardRef as ReactComponent };